import React from "react";
import { connect } from "react-redux";
import { AppointmentActions } from "../../redux/actions/AppointmentActions";
import EditAppointmentInput from "./EditAppointmentInput";
import { history } from "../../components/helpers/History";
import SearchDoctorCardListView from "../doctor/search/SearchDoctorCardListView";
import { DoctorAction } from "../../redux/actions/DoctorAction";
import {
  Button,
  Paper,
  Divider,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Box,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Hidden,
  withStyles,
} from "@material-ui/core";

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});
class EditAppointment extends React.Component {
  constructor(props) {
    super(props);
    const { appointmentId } = this.props.match.params;
    this.state = {
      appointmentId: appointmentId,
      isAppointmentUpdated: false,
      appointmentInfo : {},
      doctorId:'',
      showDoctorList : false,
    };
  }

  componentDidMount() {
    this.props.getAppointmentById(this.state.appointmentId);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isAppointmentUpdated && !this.state.isAppointmentUpdated) {
      this.setState({ isAppointmentUpdated: true });
      this.props.clearAll();
      if (this.props.handleUpdateAppointment) {
        this.props.handleUpdateAppointment();
      } else {
        history.goBack();
      }
    }
    if(this.state.appointmentInfo && !this.state.appointmentInfo.id  && this.props.appointmentInfo && this.props.appointmentInfo.id && this.props.appointmentInfo.id.length > 0
      ){
        this.setState({
          appointmentInfo:this.props.appointmentInfo,
          doctorId:this.props.appointmentInfo.doctorId});
    }
    
      
      
        
    
  }

  handleUpdateAppointment = (values) => {
    console.log(this.props.appointmentInfo.doctorId);
    console.log(values);
    //this.props.updateAppointment(values);
    let appointmentInfo = this.state.appointmentInfo;
    appointmentInfo.startDateTime = values.startDateTime;
    appointmentInfo.description = values.description;
    this.setState({appointmentInfo:appointmentInfo});
    this.props.reScheduleAppointment(values);
  };

  chooseDifferentDoctor = (data) => {
    console.log(JSON.stringify(data));
    var payload = {
      startDateTime: data.startDateTime,
      endDateTime: "",
    };
    let appointmentInfo = this.state.appointmentInfo;
    appointmentInfo.startDateTime = data.startDateTime;
    this.setState({appointmentInfo:appointmentInfo});
    this.props.searchDoctor(payload);
    this.setState({showDoctorList:true});
  };

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Typography gutterBottom variant="h4" color="primary" className={classes.typography}>
          APPOINTMENT DETAILS
        </Typography>

        {this.state.appointmentInfo && this.state.appointmentInfo.id ? (
          <>
            {this.state.showDoctorList?
            <Container component="main" maxWidth="sm">
              <CssBaseline />
              <Paper className={classes.paper}>
                {this.props.searchResult && this.props.searchResult.length > 0?
                
                
                <SearchDoctorCardListView
                  doctors={this.props.searchResult}
                  showBookNowBtn={true}
                  showNotAvailabe={this.state.showNotAvailabe}
                  handleBookAppointment={(doctorId) => {
                    this.setState({doctorId:doctorId});
                    this.props.clearAll();
                    this.setState({showDoctorList:false});
                  }}
                ></SearchDoctorCardListView>
                :<>
                <Typography gutterBottom variant="h4" color="secnodary" className={classes.typography}>
                  No doctor available.
                </Typography> 
              <Button
              variant="contained"
              color="default"
              className={classes.button}
              onClick={() => {
                this.setState({showDoctorList:false});
              }}
            >
              Back
            </Button>
              </>
              }
              </Paper>
            </Container>
            :

            <EditAppointmentInput
              appointmentInfo={this.state.appointmentInfo}
              handleUpdateAppointment={(values) => {
                this.handleUpdateAppointment(values);
              }}
              doctorId = {this.state.doctorId}
              chooseDifferentDoctor={(data) => {
                this.chooseDifferentDoctor(data);
              }}
            />}
          </>
        ) : null}
      </>
    );
  }
}

function mapStateToProps(state) {
  const user = state.authentication.user;
  const appointmentInfo = state.appointment.appointmentInfo;
  const isAppointmentUpdated = state.appointment.isAppointmentUpdated;
  const searchResult = state.doctor.searchResult;
  return { user, isAppointmentUpdated, appointmentInfo, searchResult };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAppointmentById: (id) => {
      dispatch(AppointmentActions.getAppointmentById(id));
    },
    updateAppointment: (values) => {
      dispatch(AppointmentActions.updateAppointment(values));
    },
    clearAll: () => {
      dispatch(AppointmentActions.clearAll());
    },
    reScheduleAppointment: (payload) => {
      dispatch(AppointmentActions.reScheduleAppointment(payload));
    },
    searchDoctor: (payload) => {
      dispatch(DoctorAction.searchDoctor(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(EditAppointment));
